module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0016.jpg?v=735466de";